import { useMutation, useQueryClient } from 'react-query'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'
import { useToast } from '@chakra-ui/react'

import { VISIBLE_ECOS } from '../constants'

const deleteVisibleEcos = async (id: number) => {
  await fetchAPI({
    path: `/visible_ecos/${id}`,
    method: 'delete',
  })
}

export const useDeleteVisibleEcos = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(deleteVisibleEcos, {
    async onSuccess() {
      await queryClient.refetchQueries([VISIBLE_ECOS])

      toast({
        description: t('views.admin.messages.services.delete_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
